module.exports = __webpack_public_path__ + "img/chip_50k.493db046.png";